import {Container, DivButtons, HeartIcon, HouseDoorIcon,} from "./styles";
import {Button, IcoDone, Label, TitleH3} from "components/generic";
import {NavLink, useNavigate} from "react-router-dom";
import {theme} from "styles/theme";
import {useTranslation} from "react-i18next";
import {IHousesStudentStripe, RoleUser} from "interfaces/intarfaces";
import {useContextHospi} from "context/ContextHospi";
import {STUDENT_CHATS_ROUTE, STUDENT_ROOMINFO_ROUTE} from "utils/constants";
import {isoDate} from "utils/helpers";
import photo_default from "assets/images/Placeholderimage.png";

const date_DMY = (x: string) => {
  if (!x) return "";
  const [y, m, d] = isoDate(new Date(x)).split("-");
  return `${d}-${m}-${y}`;
};

export const RoomCard: React.FC<
  IHousesStudentStripe & {
    deleteRoom: (id: string, host_id: string) => void;
    changeLiked: (id: string, host_id: string, is_liked: boolean) => void;
  }
> = ({
  house_id,
  user_id,
  photos,
  verification_status,
  available_from,
  available_to,
  street,
  city,
  bedroom_area,
  kind,
  price,
  is_favorited,
  changeLiked,
}) => {
    const { userStatus } = useContextHospi();
    const navigate = useNavigate();
    const user: RoleUser = userStatus || "student";
    const { t, i18n } = useTranslation(user);

    return (
      <Container>
        <div>
          <NavLink to={`/${i18n.language}${STUDENT_ROOMINFO_ROUTE.slice(5)}/${house_id}`} key="#">
            <div className="image">
              {verification_status ? (
                <div className="label">
                  <Label fontColor="white" bgColor={theme.colors.thirdly}>
                    {t(`myRooms.verifiedTooltip`)}
                  </Label>
                  <IcoDone size="1.4em" color={theme.colors.text} />
                  {t("myRooms.verified")}
                </div>
              ) : null}

              <img
                src={(photos && photos[0].url) || photo_default}
                alt="appartment"
              />

            </div>
            <div className="dates">
              {date_DMY(available_from)} - {available_to === '2101-01-01' ? t(`myRooms.anyDate`) : date_DMY(available_to)}
            </div>
            <TitleH3>{street}</TitleH3>
            <div className="city">{city}</div>
            <div className="info">
              <span className="price">€{price},-</span>
              <span className="size">
                <span className="number">{bedroom_area}</span> m2
              </span>
              <span className="option">
                <HouseDoorIcon />
                {t(`myRooms.card.${kind}`)}
              </span>
            </div>
          </NavLink>
        </div>
        <DivButtons>
          {is_favorited ? (
            <>
              <Button
                normal
                w="100%"
                onClick={() => navigate(`/${i18n.language}${STUDENT_CHATS_ROUTE.slice(5)}`  + `/${user_id}/${house_id}`)}
              >
                {t("myRooms.startChat")}
              </Button>
              <Button
                normal
                w="100%"
                onClick={() => changeLiked(house_id!, user_id!, true)}
              >
                {t("myRooms.removeFromLikedButton")}
              </Button>
            </>
          ) : (
            <>
              <Button
                normal
                w="100%"
                onClick={() => changeLiked(house_id!, user_id!, false)}
              >
                <HeartIcon />
              </Button>
            </>
          )}
        </DivButtons>
        {/* This layout is available only if liked */}
        {is_favorited ? <NavLink to={`/${i18n.language}${STUDENT_ROOMINFO_ROUTE.slice(5)}/${house_id}`} key="#"><div className="layout"></div></NavLink> : null}
      </Container>
    );
  };
